<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form ref="form" lazy-validation style="height: calc(100% - 64px)">
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่ม Webhook</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" v-else>
          <v-list-item-title>
            {{
              webhookInit.topic ? webhookInit.topic.title : 'ตั้งค่า Webhook'
            }}
          </v-list-item-title>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="d-flex flex-column" style="height: 100%">
          <v-tabs v-model="tab">
            <v-tab class="text-capitalize">ตั้งค่า Webhook</v-tab>
            <v-tab class="text-capitalize" v-if="formAction === 'edit'"
              >Test Webhook</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tab" style="height: 100%">
            <v-tab-item style="height: 100%; overflow-y: auto">
              <div class="py-4">
                <div class="px-4">
                  <label class="body-2">เปิด / ปิด การใช้งาน</label>
                  <v-switch
                    class="mt-0"
                    inset
                    dense
                    v-model="webhook.is_receive_real"
                  ></v-switch>
                </div>
                <div class="mb-4">
                  <div class="px-4">
                    <label class="body-2">
                      Subscription
                      <span class="red--text"><strong>*</strong></span>
                    </label>
                    <v-select
                      v-model="webhook.topic_code"
                      :items="[
                        {
                          title: 'New Transaction',
                          value: 'mastertime.Transaction.New',
                        },
                      ]"
                      :rules="[(v) => !!v || 'โปรดระบุ Subscription']"
                      item-text="title"
                      item-value="value"
                      required
                      outlined
                      dense
                    ></v-select>
                  </div>
                  <div class="px-4 mb-4" v-if="webhook.topic_code">
                    <label class="body-2">รูปแบบการส่งข้อมูล</label>
                    <div class="d-flex align-center">
                      <div class="d-flex align-center">
                        <input
                          type="radio"
                          id="mastertime.Transaction.New.Short"
                          value="mastertime.Transaction.New.Short"
                          v-model="webhook.data_transmission_format"
                        />
                        <label
                          for="mastertime.Transaction.New.Short"
                          class="ml-1 body-2"
                          >แบบสั้น (Short)</label
                        >
                      </div>
                      <div class="ml-4 d-flex align-center">
                        <input
                          type="radio"
                          id="mastertime.Transaction.New"
                          value="mastertime.Transaction.New"
                          v-model="webhook.data_transmission_format"
                        />
                        <label
                          for="mastertime.Transaction.New"
                          class="ml-1 body-2"
                          >แบบเต็ม (Full)</label
                        >
                      </div>
                    </div>
                    <div class="mt-1">
                      <button
                        @click="dialogViewJSON = true"
                        type="button"
                        class="text-decoration-underline"
                      >
                        example-data
                      </button>
                    </div>
                  </div>
                  <div class="px-4" v-if="webhook.topic_code">
                    <label class="body-2">สถานะการส่งข้อมูล</label>
                    <div class="d-flex align-center">
                      <div class="d-flex align-center">
                        <input
                          type="radio"
                          id="all"
                          value="all"
                          v-model="webhook.data_transmission_status"
                        />
                        <label for="all" class="ml-1 body-2"
                          >ทั้งหมด (All)</label
                        >
                      </div>
                      <div class="ml-4 d-flex align-center">
                        <input
                          type="radio"
                          id="success"
                          value="success"
                          v-model="webhook.data_transmission_status"
                        />
                        <label for="success" class="ml-1 body-2"
                          >สำเร็จ (Success)</label
                        >
                      </div>
                      <div class="ml-4 d-flex align-center">
                        <input
                          type="radio"
                          id="fail"
                          value="fail"
                          v-model="webhook.data_transmission_status"
                        />
                        <label for="fail" class="ml-1 body-2"
                          >ไม่สำเร็จ (Fail)</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="py-4">
                  <div class="px-4 mb-2">
                    <label class="body-2 d-block">Basic Authentication</label>
                  </div>
                  <div class="px-4 d-flex">
                    <div class="d-flex flex-column">
                      <label class="body-2">Key</label>
                      <v-card outlined color="#EEE" style="padding: 7px 10px">
                        authentication_id
                      </v-card>
                      <v-card
                        outlined
                        color="#EEE"
                        class="mt-1"
                        style="padding: 7px 10px"
                      >
                        authentication_secret
                      </v-card>
                    </div>
                    <div class="ml-2 d-flex flex-column flex-grow-1">
                      <label class="body-2">
                        Value
                        <span class="red--text"><strong>*</strong></span>
                        <span class="caption"> (min = 8, max = 128)</span>
                      </label>
                      <v-text-field
                        v-model="webhook.authentication_id"
                        class="fix-google-chrome"
                        :rules="[
                          (v) => !!v || 'โปรดระบุ authentication_id',
                          (v) =>
                            (v && v.length >= 8 && v.length <= 128) ||
                            'Length must be between 8 and 128 characters',
                        ]"
                        counter
                        outlined
                        dense
                        hide-details
                        @change="checkEmpty($event, 'authentication_id')"
                      ></v-text-field>
                      <v-text-field
                        v-model="webhook.authentication_secret"
                        class="fix-google-chrome mt-1"
                        :rules="[
                          (v) => !!v || 'โปรดระบุ authentication_secret',
                        ]"
                        outlined
                        dense
                        hide-details
                        @change="checkEmpty($event, 'authentication_secret')"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="mt-6 px-4">
                    <label class="body-2">
                      Receiver Endpoint
                      <span class="red--text"><strong>*</strong></span>
                    </label>
                    <v-text-field
                      v-model="webhook.webhook"
                      class="fix-google-chrome mt-1"
                      :rules="[
                        (v) => !!v || 'โปรดระบุ Endpoint',
                        (v) =>
                          /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
                            v
                          ) || 'Invalid URL',
                      ]"
                      required
                      clearable
                      outlined
                      dense
                      @change="checkEmpty($event, 'webhook')"
                    >
                    </v-text-field>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="py-4 mb-6">
                  <div class="px-4 mb-2">
                    <label class="body-2">
                      Email
                      <span class="caption ml-4"
                        ><span class="red--text">*</span> กรณี Webhook
                        มีข้อผิดพลาด</span
                      >
                    </label>
                  </div>
                  <div class="px-4">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="pl-0 text-left">Email Address</th>
                            <th class="text-right pr-0">
                              <v-btn
                                small
                                plain
                                color="grey darken-4"
                                class="text-capitalize"
                                @click="handleAddDeveloperEmail"
                              >
                                <v-icon small left>mdi-plus</v-icon>
                                add Email
                              </v-btn>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in webhook.developers"
                            :key="item.developer_uuid"
                          >
                            <td class="pl-0">{{ item.email }}</td>
                            <td class="text-right">
                              <v-btn
                                icon
                                small
                                @click="
                                  handleDeleteDeveloperEmail(
                                    item.developer_uuid
                                  )
                                "
                              >
                                <v-icon small>mdi-delete</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-dialog
                      v-model="dialogEmailList"
                      persistent
                      max-width="680px"
                    >
                      <v-card>
                        <v-card-title>Select Emails</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="py-4">
                          <v-simple-table dense fixed-header height="300px">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="pl-0 text-left">Email Address</th>
                                  <th class="text-right pr-0">
                                    <v-btn
                                      small
                                      depressed
                                      color="primary"
                                      class="text-capitalize"
                                      @click="dialogEmailAddForm = true"
                                    >
                                      add email
                                    </v-btn>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in developerEmails.filter(
                                    ({ email }) =>
                                      email
                                        .toLowerCase()
                                        .includes(searchEmail.toLowerCase())
                                  )"
                                  :key="item.developer_uuid"
                                >
                                  <td class="pl-0 d-flex align-center">
                                    <input
                                      v-model="selectedDeveloperEmail"
                                      type="checkbox"
                                      :id="item.email"
                                      :value="item"
                                    />
                                    <label class="ml-2" :for="item.email">
                                      {{ item.email }}
                                    </label>
                                  </td>
                                  <td class="text-right">
                                    <v-btn
                                      icon
                                      small
                                      @click="handleDeleteDialogEmailList(item)"
                                    >
                                      <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            depressed
                            @click="handleSubmitDialogEmailList"
                            >ตกลง</v-btn
                          >
                          <v-btn depressed @click="handleCancelDialogEmailList"
                            >ยกเลิก</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogEmailAddForm"
                      persistent
                      max-width="480px"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">Add Email Developer</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-form ref="formEmailAddForm" lazy-validation>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="developerEmail"
                                    :rules="[
                                      (v) => !!v || 'โปรดระบุ Email',
                                      (v) =>
                                        (v &&
                                          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                            v
                                          )) ||
                                        'Invalid email format',
                                    ]"
                                    label="Email Address"
                                    required
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="handleSubmitEmailAddForm"
                            :loading="loadingEmailAddForm"
                          >
                            ตกลง
                          </v-btn>
                          <v-btn
                            text
                            :disabled="loadingEmailAddForm"
                            @click="handleCancelEmailAddForm"
                          >
                            ยกเลิก
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item style="height: 100%; overflow-y: auto">
              <div class="px-4 py-4">
                <VueJsonPretty
                  :data="webhook.topic ? webhook.topic.ping_payload : {}"
                />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isWebhookDataChange && formAction === 'edit'"
        >
          <v-btn
            v-if="tab === 0"
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::webhook:subscription:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            v-if="tab === 1"
            class="primary"
            depressed
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::webhook:subscription:ping:post')
            "
            @click="handleTestPingSendData"
          >
            Send Data
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::webhook:subscription:create')
            "
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            class="primary mr-3"
            depressed
            v-else
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::webhook:subscription:update')
            "
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogViewJSON" scrollable max-width="50%">
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span>JSON Data</span
          ><v-btn icon @click="dialogViewJSON = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 60%" class="py-4">
          <VueJsonPretty
            :data="
              topics.find(
                (topic) => topic.topic_code === webhook.data_transmission_format
              )?.ping_payload
            "
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteEmail"
      :loading="confirmDialogDeleteEmailLoading"
      :dialogData="confirmDialogDeleteEmailData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteEmail"
      @submitConfirmDialog="submitConfirmDialogDeleteEmail"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    VueJsonPretty,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    webhook: {
      type: Object,
    },
    webhookInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogViewJSON: false,
      tab: null,
      dialogEmailList: false,
      dialogEmailAddForm: false,
      loadingEmailAddForm: false,
      developerEmail: '',
      searchEmail: '',
      selectedDeveloperEmail: [],
      developerEmails: [],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDeleteEmail: false,
      confirmDialogDeleteEmailLoading: false,
      confirmDialogDeleteEmailData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isWebhookDataChange() {
      if (
        this.webhook.is_receive_real !== this.webhookInit.is_receive_real ||
        this.webhook.topic_code !== this.webhookInit.topic_code ||
        this.webhook.data_transmission_format !==
          this.webhookInit.data_transmission_format ||
        this.webhook.data_transmission_status !==
          this.webhookInit.data_transmission_status ||
        this.webhook.authentication_id !== this.webhookInit.authentication_id ||
        this.webhook.authentication_secret !==
          this.webhookInit.authentication_secret ||
        this.webhook.webhook !== this.webhookInit.webhook ||
        JSON.stringify(this.webhook.developers) !==
          JSON.stringify(this.webhookInit.developers)
      ) {
        this.$emit('isWebhookDataChange', true)
        return true
      }
      this.$emit('isWebhookDataChange', false)
      return false
    },
    topics() {
      return this.$store.state.webhook.topics
    },
  },
  methods: {
    ...mapActions({
      fetchWebhookDeveloperEmails: 'webhook/fetchWebhookDeveloperEmails',
      addWebhookSubscription: 'webhook/addWebhookSubscription',
      editWebhookSubscription: 'webhook/editWebhookSubscription',
      deleteWebhookSubscription: 'webhook/deleteWebhookSubscription',
      addWebhookDeveloperEmail: 'webhook/addWebhookDeveloperEmail',
      deleteWebhookDeveloperEmail: 'webhook/deleteWebhookDeveloperEmail',
      testPingWebhook: 'webhook/testPingWebhook',
    }),
    handleDeleteDialogEmailList(item) {
      this.confirmDialogDeleteEmail = true
      this.confirmDialogDeleteEmailData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Email',
        value: item.email || 'Email',
        item,
      }
    },
    cancelConfirmDialogDeleteEmail() {
      this.confirmDialogDeleteEmail = false
    },
    async submitConfirmDialogDeleteEmail(item) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDialogDeleteEmailLoading = true

        const payload = {
          company_uuid,
          developer_uuid: item.developer_uuid,
        }

        await this.deleteWebhookDeveloperEmail(payload)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteEmailLoading = false
        this.confirmDialogDeleteEmail = false
      }
    },
    handleCancelEmailAddForm() {
      this.dialogEmailAddForm = false
      this.developerEmail = ''
      this.$refs.form.resetValidation()
    },
    async handleSubmitEmailAddForm() {
      if (this.$refs.formEmailAddForm.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.loadingEmailAddForm = true

          const payload = {
            company_uuid,
            body: {
              email: this.developerEmail,
            },
          }

          await this.addWebhookDeveloperEmail(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.loadingEmailAddForm = false
          this.dialogEmailAddForm = false
          this.developerEmail = ''
          this.$refs.formEmailAddForm.resetValidation()
        }
      }
    },
    async handleTestPingSendData() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          subscription_uuid: this.webhook.subscription_uuid,
        }

        await this.testPingWebhook(payload)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ส่งข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        // TODO: ignore error code
        if (error.code === 'ERR_NETWORK') {
          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ส่งข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleCancelDialogEmailList() {
      this.dialogEmailList = false
      this.selectedDeveloperEmail = []
    },
    handleSubmitDialogEmailList() {
      if (this.selectedDeveloperEmail.length > 0) {
        this.selectedDeveloperEmail.forEach((item) => {
          if (
            !this.webhook.developers.some((dev) => dev.email === item.email)
          ) {
            this.webhook.developers.push({
              developer_uuid: item.developer_uuid,
              email: item.email,
            })
          }
        })
      }
      this.dialogEmailList = false
      this.selectedDeveloperEmail = []
    },
    async handleAddDeveloperEmail() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        await this.fetchWebhookDeveloperEmails({ company_uuid })
        this.developerEmails = this.$store.state.webhook.developerEmails

        this.dialogEmailList = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleDeleteDeveloperEmail(developer_uuid) {
      this.webhook.developers = this.webhook.developers.filter(
        (item) => item.developer_uuid !== developer_uuid
      )
    },
    checkEmpty(value, field) {
      if (value) {
        this.webhook[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Webhook',
        value: this.webhook.topic?.title || 'Webhook',
        item: this.webhook,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(item) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteWebhookSubscription({
        company_uuid,
        subscription_uuid: item.subscription_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          let topic_code = this.webhook.topic_code
          if (
            this.webhook.data_transmission_format ===
            'mastertime.Transaction.New.Short'
          ) {
            topic_code += '.Short'
          }
          if (this.webhook.data_transmission_status === 'success') {
            topic_code += '.Pass'
          } else if (this.webhook.data_transmission_status === 'fail') {
            topic_code += '.Fail'
          }

          const payload = {
            company_uuid,
            body: {
              webhook: this.webhook.webhook,
              topic_code,
              authentication_mechanism: 'Basic',
              authentication_id: this.webhook.authentication_id,
              authentication_secret: this.webhook.authentication_secret,
              is_receive_test: true,
              is_receive_real: this.webhook.is_receive_real,
              developer_uuids: this.webhook.developers.map(
                (item) => item.developer_uuid
              ),
            },
          }

          await this.addWebhookSubscription(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          let topic_code = this.webhook.topic_code
          if (
            this.webhook.data_transmission_format ===
            'mastertime.Transaction.New.Short'
          ) {
            topic_code += '.Short'
          }
          if (this.webhook.data_transmission_status === 'success') {
            topic_code += '.Pass'
          } else if (this.webhook.data_transmission_status === 'fail') {
            topic_code += '.Fail'
          }

          const payload = {
            company_uuid,
            subscription_uuid: this.webhook.subscription_uuid,
            body: {
              webhook: this.webhook.webhook,
              topic_code,
              authentication_mechanism: 'Basic',
              authentication_id: this.webhook.authentication_id,
              authentication_secret: this.webhook.authentication_secret,
              is_receive_test: true,
              is_receive_real: this.webhook.is_receive_real,
              developer_uuids: this.webhook.developers.map(
                (item) => item.developer_uuid
              ),
            },
          }

          await this.editWebhookSubscription(payload)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onClose() {
      if (this.isWebhookDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
    },
    onReset() {
      this.$refs.form.resetValidation()
      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
